// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"77805773","575":"5c7fbbc6","690":"b8bec7d1","787":"3ce4cc4d","824":"dafa1b26"}[chunkId] + ".chunk.js";
};